//@flow
import { useTheme } from "@mui/material/styles";
import React, {useContext} from 'react';
import Box from "@mui/material/Box";
import {TitleContext} from "./content";

export const Title = ({after, children, showLogo}) => {
	const {title} = useContext(TitleContext)
	const theme = useTheme();
	return (
		<React.Fragment>
			<Box
				sx={{
					pl: 1,
					color: theme.palette.primary[800]
				}}
			>
				{children}
				{title}
			</Box>
		</React.Fragment>
	)
}